import { render, staticRenderFns } from "./CompPage.vue?vue&type=template&id=081a0fd9&scoped=true"
import script from "./CompPage.vue?vue&type=script&lang=js"
export * from "./CompPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081a0fd9",
  null
  
)

export default component.exports